import cn from 'classnames';

interface OrDividerProps {
  className?: string;
}

/**
 * OR 分隔线组件
 */
export function OrDivider({ className }: OrDividerProps) {
  return (
    <div className={cn('flex w-full items-center justify-center gap-[13px]', className)}>
      <div className="h-[1px] flex-1 bg-[#e5e5e5]" />
      <span className="text-[14px] font-normal leading-[20px] text-[#a3a3a3]">OR</span>
      <div className="h-[1px] flex-1 bg-[#e5e5e5]" />
    </div>
  );
}

export default OrDivider;
